/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommissionHistoryDto } from '../models';
/**
 * RestCommissionHistoryApi - axios parameter creator
 */
export const RestCommissionHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get current user\'s approved commission history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserCommissionHistory: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/commissions/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestCommissionHistoryApi - functional programming interface
 */
export const RestCommissionHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestCommissionHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get current user\'s approved commission history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUserCommissionHistory(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommissionHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUserCommissionHistory(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCommissionHistoryApi.getCurrentUserCommissionHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestCommissionHistoryApi - factory interface
 */
export const RestCommissionHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestCommissionHistoryApiFp(configuration)
    return {
        /**
         * 
         * @summary Get current user\'s approved commission history
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserCommissionHistory(options?: RawAxiosRequestConfig): AxiosPromise<CommissionHistoryDto> {
            return localVarFp.getCurrentUserCommissionHistory(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestCommissionHistoryApi - interface
 */
export interface RestCommissionHistoryApiInterface {
    /**
     * 
     * @summary Get current user\'s approved commission history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCurrentUserCommissionHistory(options?: RawAxiosRequestConfig): AxiosPromise<CommissionHistoryDto>;

}

/**
 * RestCommissionHistoryApi - object-oriented interface
 */
export class RestCommissionHistoryApi extends BaseAPI implements RestCommissionHistoryApiInterface {
    /**
     * 
     * @summary Get current user\'s approved commission history
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentUserCommissionHistory(options?: RawAxiosRequestConfig) {
        return RestCommissionHistoryApiFp(this.configuration).getCurrentUserCommissionHistory(options).then((request) => request(this.axios, this.basePath));
    }
}

